angular.module('cvsApp').service('nativeBridgeService', nativeBridge);

function nativeBridge($state, cvsAppData) {
    var callbacks = {
        navigateBack: function() { // native function navigate to previous page.
            var currentState = $state.current.name;
            var reviewOrder = cvsAppData.getReviewOrder();
            var onLoadStoreLocator = cvsAppData.isOnload();
            if (currentState === 'GR' || currentState === 'QR' || currentState === 'system-error') {
                native.gotoPage('Home'); // call the native method to take the user to home page.
            } else if(currentState === 'storelocator' && !reviewOrder){
                native.gotoPage('Home');
            } else if(currentState === 'store-detail' && !reviewOrder && onLoadStoreLocator){
                $state.go('storelocator', {reload: true});
            } else if(currentState === 'store-detail' && !reviewOrder && !onLoadStoreLocator){
                $state.go('storelocator', {reload: true});
            }else if (currentState === 'checkout-confirmation') {
                if (!cvsAppData.isGuestRefill() && cvsUtility.queryMap.tokenId) {
                    $state.go('dashboard-refill-prescriptions');
                } else {
                    $state.go('GR');
                }
            } else {
                window.history.back(); // navigate to previous page.
            }
        }
    };


    this.registerCallbacks = function() { // bind the callback object to window object.
        angular.forEach(Object.keys(callbacks), function(callback) {
            window[callback] = callbacks[callback];
        });
    };

}